import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CatDrawer } from "blocks-nextjs/blocks-react/components/Drawer";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconArrowBack } from "blocks-nextjs/blocks-react/components/Icons/ArrowBack/ArrowBack";
import React, { useEffect, useState } from "react";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";
import ChargerPageDetail from "../../pages/Projects/ChargerPageDetail";
const DRAWER_WIDTH = "75%";
const BACK_BUTTON_CLASSES = "flex items-center gap-2 cursor-pointer hover:opacity-80";
const BACK_ICON_CLASSES = "w-5 h-5 mt-1";
const ChargerAssetDrawer = ({ assetDrawerActive, setAssetDrawerActive }) => {
    const [isRefreshComponent, setIsRefreshComponent] = useState(assetDrawerActive);
    const [showGenerateLink, setShowGenerateLink] = useState(false);
    const [showChargeHistory, setShowChargeHistory] = useState(false);
    // Lock body scroll when drawer is active
    useBodyScrollLock(assetDrawerActive);
    useBodyScrollLock(showChargeHistory);
    const handleGenerateLinkStateChange = (isGenerateLink) => {
        setShowGenerateLink(isGenerateLink);
    };
    const handleChargeHistoryStateChange = (isChargeHistory) => {
        setShowChargeHistory(isChargeHistory);
    };
    const handleBackClick = () => {
        setShowGenerateLink(false);
        setShowChargeHistory(false);
    };
    useEffect(() => {
        setIsRefreshComponent(assetDrawerActive);
        // Reset showGenerateLink and showChargeHistory when drawer closes
        if (!assetDrawerActive) {
            setShowGenerateLink(false);
            setShowChargeHistory(false);
        }
    }, [assetDrawerActive]);
    return (_jsx(CatDrawer, { className: "custom-drawer", "data-test": "asset-details-drawer", disableBackdropClick: false, disableEscClick: true, hasBackdrop: true, isActive: assetDrawerActive, isInline: true, onBlDrawerClose: () => {
            setAssetDrawerActive(false);
        }, onBlDrawerOpen: () => { }, preserveContent: true, width: DRAWER_WIDTH, children: _jsxs(_Fragment, { children: [_jsx("div", { className: "custom-drawer-header", "data-test": "asset-details-drawer-header", slot: "header", children: _jsx(CatHeading, { "data-test": "asset-details-drawer-title", level: "h1", variant: "title", children: showChargeHistory ? (_jsxs("button", { className: BACK_BUTTON_CLASSES, onClick: handleBackClick, type: "button", children: [_jsx(CatIconArrowBack, { className: BACK_ICON_CLASSES }), _jsx("span", { children: "Transaction History" })] })) : showGenerateLink ? (_jsxs("button", { className: BACK_BUTTON_CLASSES, onClick: handleBackClick, type: "button", children: [_jsx(CatIconArrowBack, { className: BACK_ICON_CLASSES }), _jsx("span", { children: "Back" })] })) : ("Asset Details") }) }), _jsx(ChargerPageDetail, { isDrawerActive: assetDrawerActive, isRefreshComponent: isRefreshComponent, onChargeHistoryStateChange: handleChargeHistoryStateChange, onCloseDrawer: () => setAssetDrawerActive(false), onGenerateLinkStateChange: handleGenerateLinkStateChange, showChargeHistory: showChargeHistory, showGenerateLink: showGenerateLink })] }) }));
};
export default ChargerAssetDrawer;
